import { jsx as b } from "react/jsx-runtime";
import { forwardRef as he, useRef as D, useImperativeHandle as Se, useEffect as y, useCallback as F, useMemo as Q } from "react";
import ve from "../../../make-event-props/dist/esm/index.es.js";
import Pe from "../../../make-cancellable-promise/dist/esm/index.es.js";
import { clsx as we } from "../../../clsx/dist/clsx.es.js";
import X from "../../../tiny-invariant/dist/esm/tiny-invariant.es.js";
import R from "../../../warning/warning.es.js";
import { dequal as Y } from "../../../dequal/dist/index.es.js";
import * as Ee from "../../node_modules/pdfjs-dist/build/pdf.es.js";
import { getDocument as be } from "../../node_modules/pdfjs-dist/build/pdf.es.js";
import De from "./DocumentContext.es.js";
import B from "./Message.es.js";
import Re from "./LinkService.es.js";
import Z from "./PasswordResponses.es.js";
import { isDataURI as ee, dataURItoByteString as re, displayCORSWarning as ne, isArrayBuffer as ke, isBrowser as Oe, isBlob as Le, loadFromFile as xe, cancelRunningTask as Ce } from "./shared/utils.es.js";
import te from "./shared/hooks/useResolver.es.js";
var Ie = function(r, u, o, n) {
  function s(f) {
    return f instanceof o ? f : new o(function(p) {
      p(f);
    });
  }
  return new (o || (o = Promise))(function(f, p) {
    function k(c) {
      try {
        v(n.next(c));
      } catch (m) {
        p(m);
      }
    }
    function e(c) {
      try {
        v(n.throw(c));
      } catch (m) {
        p(m);
      }
    }
    function v(c) {
      c.done ? f(c.value) : s(c.value).then(k, e);
    }
    v((n = n.apply(r, u || [])).next());
  });
}, oe = function(r, u) {
  var o = {};
  for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && u.indexOf(n) < 0 && (o[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, n = Object.getOwnPropertySymbols(r); s < n.length; s++)
      u.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[s]) && (o[n[s]] = r[n[s]]);
  return o;
};
const { PDFDataRangeTransport: _e } = Ee, je = (r, u) => {
  switch (u) {
    case Z.NEED_PASSWORD: {
      const o = prompt("Enter the password to open this PDF file.");
      r(o);
      break;
    }
    case Z.INCORRECT_PASSWORD: {
      const o = prompt("Invalid password. Please try again.");
      r(o);
      break;
    }
  }
};
function ie(r) {
  return typeof r == "object" && r !== null && ("data" in r || "range" in r || "url" in r);
}
const Ke = he(function(u, o) {
  var { children: n, className: s, error: f = "Failed to load PDF file.", externalLinkRel: p, externalLinkTarget: k, file: e, inputRef: v, imageResourcesPath: c, loading: m = "Loading PDF…", noData: x = "No PDF file specified.", onItemClick: O, onLoadError: N, onLoadProgress: A, onLoadSuccess: V, onPassword: M = je, onSourceError: q, onSourceSuccess: U, options: g, renderMode: W, rotate: z } = u, J = oe(u, ["children", "className", "error", "externalLinkRel", "externalLinkTarget", "file", "inputRef", "imageResourcesPath", "loading", "noData", "onItemClick", "onLoadError", "onLoadProgress", "onLoadSuccess", "onPassword", "onSourceError", "onSourceSuccess", "options", "renderMode", "rotate"]);
  const [ae, P] = te(), { value: l, error: C } = ae, [se, w] = te(), { value: i, error: I } = se, h = D(new Re()), E = D([]), _ = D(void 0), j = D(void 0);
  e && e !== _.current && ie(e) && (R(!Y(e, _.current), `File prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "file" prop.`), _.current = e), g && g !== j.current && (R(!Y(g, j.current), `Options prop passed to <Document /> changed, but it's equal to previous one. This might result in unnecessary reloads. Consider memoizing the value passed to "options" prop.`), j.current = g);
  const $ = D({
    // Handling jumping to internal links target
    scrollPageIntoView: (t) => {
      const { dest: a, pageNumber: d, pageIndex: S = d - 1 } = t;
      if (O) {
        O({ dest: a, pageIndex: S, pageNumber: d });
        return;
      }
      const L = E.current[S];
      if (L) {
        L.scrollIntoView();
        return;
      }
      R(!1, `An internal link leading to page ${d} was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.`);
    }
  });
  Se(o, () => ({
    linkService: h,
    pages: E,
    viewer: $
  }), []);
  function ce() {
    U && U();
  }
  function ue() {
    C && (R(!1, C.toString()), q && q(C));
  }
  function fe() {
    P({ type: "RESET" });
  }
  y(fe, [e, P]);
  const H = F(() => Ie(this, void 0, void 0, function* () {
    if (!e)
      return null;
    if (typeof e == "string")
      return ee(e) ? { data: re(e) } : (ne(), { url: e });
    if (e instanceof _e)
      return { range: e };
    if (ke(e))
      return { data: e };
    if (Oe && Le(e))
      return { data: yield xe(e) };
    if (X(typeof e == "object", "Invalid parameter in file, need either Uint8Array, string or a parameter object"), X(ie(e), "Invalid parameter object: need either .data, .range or .url"), "url" in e && typeof e.url == "string") {
      if (ee(e.url)) {
        const { url: t } = e, a = oe(e, ["url"]), d = re(t);
        return Object.assign({ data: d }, a);
      }
      ne();
    }
    return e;
  }), [e]);
  y(() => {
    const t = Pe(H());
    return t.promise.then((a) => {
      P({ type: "RESOLVE", value: a });
    }).catch((a) => {
      P({ type: "REJECT", error: a });
    }), () => {
      Ce(t);
    };
  }, [H, P]), y(() => {
    if (!(typeof l > "u")) {
      if (l === !1) {
        ue();
        return;
      }
      ce();
    }
  }, [l]);
  function de() {
    i && (V && V(i), E.current = new Array(i.numPages), h.current.setDocument(i));
  }
  function le() {
    I && (R(!1, I.toString()), N && N(I));
  }
  y(function() {
    w({ type: "RESET" });
  }, [w, l]), y(function() {
    if (!l)
      return;
    const a = g ? Object.assign(Object.assign({}, l), g) : l, d = be(a);
    A && (d.onProgress = A), M && (d.onPassword = M);
    const S = d, L = S.promise.then((T) => {
      w({ type: "RESOLVE", value: T });
    }).catch((T) => {
      S.destroyed || w({ type: "REJECT", error: T });
    });
    return () => {
      L.finally(() => S.destroy());
    };
  }, [g, w, l]), y(() => {
    if (!(typeof i > "u")) {
      if (i === !1) {
        le();
        return;
      }
      de();
    }
  }, [i]), y(function() {
    h.current.setViewer($.current), h.current.setExternalLinkRel(p), h.current.setExternalLinkTarget(k);
  }, [p, k]);
  const G = F((t, a) => {
    E.current[t] = a;
  }, []), K = F((t) => {
    delete E.current[t];
  }, []), pe = Q(() => ({
    imageResourcesPath: c,
    linkService: h.current,
    onItemClick: O,
    pdf: i,
    registerPage: G,
    renderMode: W,
    rotate: z,
    unregisterPage: K
  }), [c, O, i, G, W, z, K]), me = Q(
    () => ve(J, () => i),
    // biome-ignore lint/correctness/useExhaustiveDependencies: FIXME
    [J, i]
  );
  function ge() {
    return b(De.Provider, { value: pe, children: n });
  }
  function ye() {
    return e ? i == null ? b(B, { type: "loading", children: typeof m == "function" ? m() : m }) : i === !1 ? b(B, { type: "error", children: typeof f == "function" ? f() : f }) : ge() : b(B, { type: "no-data", children: typeof x == "function" ? x() : x });
  }
  return b("div", Object.assign({
    className: we("react-pdf__Document", s),
    // Assertion is needed for React 18 compatibility
    ref: v,
    style: {
      "--scale-factor": "1"
    }
  }, me, { children: ye() }));
});
export {
  Ke as default
};
//# sourceMappingURL=Document.es.js.map
